import { useMemo } from 'react';

import { formatDateFactory } from 'shared/utils';

import { useDateFormat } from './useDateTimeFormat';

export const useFormatDate = () => {
  const dateFormat = useDateFormat();

  return useMemo(() => formatDateFactory(dateFormat), [dateFormat]);
};

export type FormatDate = ReturnType<typeof useFormatDate>;
